module.exports = __webpack_public_path__ + "img/movieTheater-3.8b85a6dd.jpg";